
import Vue from 'vue';
import Component from 'vue-class-component';
import LookupMixin from './lookupMixin';
import { ResolveController } from 'rt/UIApiControllers/UI/Smart/ResolveController';

@Component({
  name: 'OpportunityInput',
})
export default class OpportunityInput extends LookupMixin {
  resolveController = new ResolveController(Vue.axios);

  async resolve(id: number): Promise<string> {
    return (await this.resolveController.Opportunity(id)).name;
  }

  protected get identifier(): string {
    return 'Opportunity';
  }

  get anagraphicContext(): any {
    const ctx: any = {};
    if (this.data?.companyId > 0) {
      ctx.companyId = this.data.companyId;
    }
    if (this.data?.contactId > 0) {
      ctx.contactId = this.data.contactId;
    }
    if (this.data?.leadId > 0) {
      ctx.leadId = this.data.leadId;
    }
    return ctx;
  }
}
